import { render, staticRenderFns } from "./signData.vue?vue&type=template&id=adfb07e6&scoped=true&"
import script from "./signData.vue?vue&type=script&lang=js&"
export * from "./signData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfb07e6",
  null
  
)

export default component.exports